export default __webpack_public_path__ + "static/media/tapicerowane3.4d92de3b.jpg";